var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCropsPhalaris(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 18C21.5938 18.0231 20.998 17.3602 20.998 17.3602V44.7843C20.998 44.7843 21.648 44.9998 22.0404 45C22.6174 45.0003 23.0108 44.2632 23.0108 44.2632V17.3602C23.0108 17.3602 22.4242 17.9759 22 18Z",
    fill: "#8CBD63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5852 31.3393C8.47192 27.7903 7.74363 21.3473 7.74363 21.3473C7.74363 21.3473 12.6685 25.7661 15.1044 29.187C16.7792 31.5391 19.3194 35.1092 20.2993 37.3057L20.2993 39.2548C20.2993 39.2548 13.151 35.6481 10.5852 31.3393Z",
    fill: "#68894F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4167 35.4367C35.53 31.8877 36.2583 25.4447 36.2583 25.4447C36.2583 25.4447 31.3334 29.8635 28.8975 33.2844C27.2227 35.6365 24.6826 39.2066 23.7027 41.4031L23.7027 43.3522C23.7027 43.3522 30.8509 39.7455 33.4167 35.4367Z",
    fill: "#8CBD63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0177 11.4398C22.444 10.4723 23.2423 9.3343 24.7744 8.24946C24.7505 4.24085 22.0177 1 22.0177 1C22.0177 1 19.2844 4.24033 19.2598 8.24893C20.8134 9.34797 21.6025 10.4949 22.0177 11.4398Z",
    fill: "#91818A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3663 9.15576C25.2758 9.76365 22.3764 11.3297 22.0141 14.7808C21.6513 11.8003 19.4776 10.0771 17.6619 9.15576C17.6619 9.15576 17.16 11.5437 18.3477 13.6844C19.5354 15.8257 21.9612 17 21.9612 17H22.067C22.067 17 24.4941 15.8257 25.6812 13.6844C26.8688 11.5437 26.3663 9.15576 26.3663 9.15576Z",
    fill: "#91818A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0876 18.5366C30.0732 18.1538 31.4424 17.9137 33.2929 18.2299C36.1104 15.3785 36.4697 11.1545 36.4697 11.1545C36.4697 11.1545 32.2457 11.513 29.3938 14.3301C29.7152 16.2059 29.4622 17.5748 29.0876 18.5366Z",
    fill: "#91818A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7763 19.9965C32.5753 19.6552 29.4178 18.7124 26.7213 20.8966C28.5722 18.5324 28.2537 15.7769 27.6213 13.8415C27.6213 13.8415 25.5779 15.1752 24.904 17.5287C24.2297 19.8827 25.1147 22.4283 25.1147 22.4283L25.1895 22.5031C25.1895 22.5031 27.736 23.389 30.0895 22.7142C32.4431 22.0403 33.7763 19.9965 33.7763 19.9965Z",
    fill: "#91818A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.928 18.5366C13.9424 18.1538 12.5732 17.9137 10.7228 18.2299C7.90522 15.3785 7.54593 11.1545 7.54593 11.1545C7.54593 11.1545 11.77 11.513 14.6219 14.3301C14.3004 16.2059 14.5534 17.5748 14.928 18.5366Z",
    fill: "#91818A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2394 19.9965C11.4403 19.6552 14.5978 18.7124 17.2944 20.8966C15.4434 18.5324 15.7619 15.7769 16.3943 13.8415C16.3943 13.8415 18.4377 15.1752 19.1116 17.5287C19.7859 19.8827 18.9009 22.4283 18.9009 22.4283L18.8261 22.5031C18.8261 22.5031 16.2796 23.389 13.9261 22.7142C11.5725 22.0403 10.2394 19.9965 10.2394 19.9965Z",
    fill: "#91818A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCropsPhalaris);
export default __webpack_public_path__ + "static/media/ic-crops-Phalaris.7c2b574b409775e602a9c47d5ee8a69d.svg";
export { ForwardRef as ReactComponent };